<template>
    <div class="c-banner-wapper">
        <LayoutContent>
            <div class="banner-content">
                <div class="c-banner-text-box">
                    <h5 class="text-item is-title">{{ $t("main:全球实时语音通话云服务") }}</h5>
                    <p class="text-item is-detail">{{ $t("main:低延迟、低耗能、稳定可靠的语音互动服务。") }}</p>
                </div>
                <BannerStatistic /></div
        ></LayoutContent>
    </div>
</template>

<script>
import LayoutContent from "@/components/UI/LayoutContent.vue";
import BannerStatistic from "@/components/UI/BannerStatistic.vue";
export default {
    name: "BannerHome",
    components: { LayoutContent, BannerStatistic },
};
</script>

<style scoped lang="less">
.c-banner-wapper {
    display: flex;
    justify-content: center;
    position: relative;
    padding-top: 80px;
    padding-left: 24px;
    padding-right: 24px;
    margin-top: -80px;
    background: #0c1126 url(https://gcloudweb-1256818929.cos.ap-shanghai.myqcloud.com/static/images/GVoice-Ex/home/banner-home-bg.png) no-repeat center center;
    .banner-content {
        display: flex;
        flex-direction: column;
        min-height: 720px;
    }
}
.c-banner-text-box {
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding-bottom: 28px;
    .text-item {
        &.is-title {
            font-size: 60px;
            letter-spacing: -0.4px;
            color: #fff;
            font-weight: normal;
        }
        &.is-detail {
            font-size: 18px;
            line-height: 1.8;
            letter-spacing: -0.6px;
            color: #a1a5af;
        }
        & + .text-item {
            margin-top: 16px;
        }
    }
}

@media only screen and (max-width: 1200px) {
    .c-banner-wapper {
        padding-top: 56px;
        .banner-content {
            min-height: 480px;
        }
    }
    .c-banner-text-box {
        .text-item {
            &.is-title {
                font-size: 40px;
            }
            &.is-detail {
                font-size: 15px;
            }
        }
    }
}
@media only screen and (max-width: 768px) {
    .c-banner-wapper {
        br {
            display: none;
        }
        .banner-content {
            min-height: 320px;
        }
    }
    .c-banner-text-box {
        .text-item {
            &.is-title {
                font-size: 32px;
            }
            &.is-detail {
                line-height: 1.6;
            }
        }
    }
}
@media only screen and (max-width: 480px) {
    .c-banner-wapper {
        .banner-content {
            min-height: 320px;
            padding-bottom: 24px;
        }
    }
    .c-banner-text-box {
        padding-bottom: 0;
        .text-item {
            &.is-title {
                font-size: 24px;
            }
        }
    }
    .c-statistic-item {
        margin-top: 0;
    }
}
</style>
